import React, { useState } from 'react'

import { useRequest } from 'ahooks'

import { qrcodePath } from '$extensionSrc/consts/urlConsts'
import CloseIcon from '$extensionSrc/icons/close-icon.svg'
import { UserSettingsModalType } from '$extensionSrc/utils/enums'

import Enroll2faAppForm from './Enroll2faAppForm'
import Enroll2faSmsForm from './Enroll2faSmsForm'
import TabToggle from './TabToggle'
import { authFetch } from '../utils/fetch'

import './Enroll2faChooseMethodModal.scss'

type TotpData = {
  code: string
  qrcode: string
}

export default function Enroll2faChooseMethodModal({
  closeModal,
  initialTab,
  setModalType,
  setPhoneNumber,
}: {
  closeModal: () => void
  initialTab: 'app' | 'sms'
  setModalType: (modalType: UserSettingsModalType) => void
  setPhoneNumber: (value) => void
}) {
  const [totpData, setTotpData] = useState<TotpData | null>(null)

  useRequest(() => authFetch(new Request(qrcodePath, { method: 'POST' })), {
    onSuccess: (response: Response) => {
      if (response.status === 200) {
        response.json().then((blob) => {
          setTotpData(blob)
        })
      }
    },
  })

  const tabContentMap = {
    sms: {
      content: (
        <Enroll2faSmsForm
          onClickConfirm={(phoneNumber) => {
            setPhoneNumber(phoneNumber)
            setModalType(UserSettingsModalType.CONFIRM_2FA_SMS)
          }}
          onClickSwitchToEnroll2faApp={() =>
            setModalType(UserSettingsModalType.ENROLL_2FA_APP)
          }
          showSkip={false}
        />
      ),
      displayName: 'Using SMS',
    },
    app: {
      content: (
        <Enroll2faAppForm
          onClickConfirm={() =>
            setModalType(UserSettingsModalType.CONFIRM_2FA_APP)
          }
          showSkip={false}
          totpCode={totpData?.code}
          totpQrcode={totpData?.qrcode}
        />
      ),
      displayName: 'Using an app',
    },
  }
  return (
    <div className="Enroll2faChooseMethodModal">
      <div className="close-icon-bar">
        <CloseIcon className="CloseIcon" onClick={() => closeModal()} />
      </div>
      <div className="header">
        <div className="heading1 bold center">Secure your account</div>
        <div className="body1 darkest-gray center">
          Choose how to verify it's you when you log in
        </div>
      </div>
      <TabToggle tabContentMap={tabContentMap} initialTab={initialTab} />
    </div>
  )
}
